import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Templates = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.9533 5.1724C1.81968 5.20155 1.73428 5.33266 1.76164 5.46666L3.65842 14.7569C3.68631 14.8935 3.82048 14.9809 3.95666 14.9512L12.5983 13.0658L12.757 13.0296C12.8753 12.9901 12.9479 12.8676 12.9224 12.7426L11.0256 3.45233C10.9977 3.31576 10.8635 3.22837 10.7274 3.25808L1.9533 5.1724ZM6.97675 15.8275L4.27641 16.4167C3.32316 16.6247 2.38392 16.0129 2.18874 15.057L0.291961 5.76673C0.100452 4.82873 0.698209 3.91095 1.63355 3.70687L10.4076 1.79256C11.3174 1.59406 12.2144 2.14223 12.464 3.02371L15.8309 3.91026C16.7482 4.1518 17.3061 5.08022 17.0887 6.00357L17.0611 6.12092L19.331 7.9041C20.064 8.47997 20.217 9.52938 19.6788 10.2905L13.7984 18.6077C13.2344 19.4053 12.1267 19.5868 11.3377 19.0109L6.97675 15.8275ZM16.6821 7.73072L15.1999 14.0271L18.454 9.42458C18.5309 9.31584 18.5091 9.16592 18.4043 9.08366L16.6821 7.73072ZM13.1456 16.9327C13.0028 16.9338 12.8575 16.9174 12.7124 16.8817L10.078 16.2342L12.2221 17.7993C12.3348 17.8816 12.493 17.8557 12.5736 17.7417L13.1456 16.9327ZM11.1092 14.9431L12.9246 14.5298L13.0505 14.5024C13.0774 14.4965 13.1041 14.49 13.1304 14.483L13.5754 14.3817L13.3735 15.2396C13.3416 15.3749 13.2055 15.4583 13.0705 15.4251L11.1092 14.9431ZM14.2374 11.5698L15.6286 5.65986C15.6597 5.52795 15.58 5.39532 15.4489 5.36081L12.8411 4.67414L14.2374 11.5698Z"
        fill={color}
      />
    </svg>
  )
})

export default Templates
